import { isSameTimeOrAfter, isSameTimeOrBefore, stringToLocalDate } from "@hex-insights/core";

type GeneralEnrollment = {
	lateStartDate: string | null;
	earlyEndDate: string | null;
};

/**
 * Determines if an enrollment is active on the given date (defaults to today).
 *
 * @note Does not consider whether the term is active, only the enrollment itself.
 */
export function isEnrollmentActive(enrollment: GeneralEnrollment, date = new Date()) {
	const isPastStart =
		enrollment.lateStartDate === null ||
		isSameTimeOrAfter(date, stringToLocalDate(enrollment.lateStartDate, "day"), "day");
	const isBeforeEnd =
		enrollment.earlyEndDate === null ||
		isSameTimeOrBefore(date, stringToLocalDate(enrollment.earlyEndDate, "day"), "day");
	return isPastStart && isBeforeEnd;
}
